import { createSlice } from '@reduxjs/toolkit';
import { removeNulls } from 'utils';
const slice = createSlice({
    name: 'UserIcons',
    initialState: () => {
        const idsIconUser = window.PRELOAD.user_icons ? window.PRELOAD.user_icons : [];
        const loading = false;
        const error = false;
        const message = null;
        return { loading, idsIconUser, error, message };
    },
    reducers: {
        addIcon: (state, action) => {
            action.payload?.add_icons.forEach((new_id) => (state.idsIconUser = [...state.idsIconUser, new_id]));
        },
        deleteIcon: (state, action) => {
            state.idsIconUser =
                state.idsIconUser &&
                    state.idsIconUser.filter((el) => el !== action.payload);
            for (let i = 0; i < localStorage.length; i++)
                if (localStorage.key(i)?.indexOf(action.payload) !== -1) {
                    const key = localStorage.key(i);
                    key && window.localStorage.removeItem(key);
                }
        },
        loadingIcon: (state) => {
            state.loading = true;
            // state.message = null;
        },
        set_message_action: (state, action) => {
            state.message = action.payload;
        },
    },
});
export const { addIcon, loadingIcon, set_message_action, deleteIcon } = slice.actions;
export const userIcons = slice.reducer;
export const addIconUser = (data) => async (dispatch, getState, { api }) => {
    if (!FormData) {
        dispatch(set_message_action({
            title: 'Неподдерживаемый браузер',
            message: 'Загрузка файлов не поддерживается в вашем браузере. Воспользуйтесь Chrome, Firefox, Opera 12+ или Internet Explorer 10+',
        }));
        return;
    }
    if (data.length === 0)
        dispatch(set_message_action({
            title: 'Нет файла для загрузки',
            message: 'Выберите файл для загрузки',
        }));
    try {
        const response = await api.uploading_icons_user(data);
        if (response.ok) {
            dispatch(set_message_action({
                title: 'Файл загружен',
            }));
        }
    }
    catch (error) {
        const { json } = error;
        dispatch(set_message_action({
            title: 'Загрузка файлов не удалась',
            message: json?.error_ui ?? 'Ошибка связи с сервером',
        }));
    }
    finally {
        dispatch(loadingIcon());
    }
};
export const deleteIconUser = (id) => async (dispatch, getState, { api }) => {
    try {
        const response = await api.delete_icons_user(id);
    }
    catch (error) {
        console.log(error);
    }
};
export const updateUiSettingsBeforeDeleteIcon = (id_delete_icon) => async (dispatch, getState, { api }) => {
    const state = getState();
    const new_ui_settings = removeNulls(state.devices.items.map(({ id, ui_settings }) => {
        if (ui_settings == null ||
            ui_settings.icons == null ||
            ui_settings.icons.web_elements == null ||
            ui_settings.icons.heating_circuits == null) {
            return null;
        }
        return {
            id,
            ui_settings: {
                ...ui_settings,
                icons: {
                    ...ui_settings.icons,
                    web_elements: Object.fromEntries(removeNulls(Object.entries(ui_settings.icons.web_elements).map(([obj_id, icon_id]) => {
                        if (icon_id === id_delete_icon) {
                            return null;
                        }
                        return [obj_id, icon_id];
                    }))),
                    heating_circuits: Object.fromEntries(removeNulls(Object.entries(ui_settings.icons.heating_circuits).map(([obj_id, icon_id]) => {
                        if (icon_id === id_delete_icon) {
                            return null;
                        }
                        return [obj_id, icon_id];
                    }))),
                },
            },
        };
    }));
    const fetchUpdate = async (id, settings) => {
        try {
            const response = await api.update_device(id, settings);
        }
        catch (error) {
            console.log(error);
        }
    };
    new_ui_settings.forEach((settings_device) => {
        fetchUpdate(settings_device.id, { ui_settings: settings_device.ui_settings });
    });
    dispatch(deleteIcon(id_delete_icon));
};
